import { render, staticRenderFns } from "./NuevoSiniestro.vue?vue&type=template&id=10a8bf3c&"
import script from "./NuevoSiniestro.vue?vue&type=script&lang=js&"
export * from "./NuevoSiniestro.vue?vue&type=script&lang=js&"
import style0 from "./NuevoSiniestro.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports